import { useQuery } from '@tanstack/react-query'
import * as zodSchemas from '@weenat/client/dist/zod-schemas'
import { useIntl } from '@weenat/wintl'
import { useSearchParams } from 'app/routx-router'
import Icons from 'app/src/kit/Icons'
import EmptyStateWithRipple from 'app/src/kit/empty-state/EmptyStateWithRipple'
import FlowPageLayout from 'app/src/layouts/FlowPageLayout'
import logEvent from 'app/utils/analytics'
import isEmpty from 'lodash-es/isEmpty'
import isNil from 'lodash-es/isNil'
import { useEffect, useState } from 'react'

export const settings = {
  search: zodSchemas.url
}

const Export = () => {
  const [searchParams] = useSearchParams(settings.search)
  const { url } = searchParams
  const { t } = useIntl()

  const [triggered, setTriggered] = useState(false)

  const urlIsDefined = !isNil(url) && !isEmpty(url) && typeof url === 'string'

  const { status } = useQuery({
    queryKey: urlIsDefined ? url : 'export',
    queryFn: async () => {
      if (urlIsDefined) {
        const response = await fetch(url, { method: 'GET', headers: { Range: `bytes=0-0` } })
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response
      }
    },
    retry: 0,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  })

  const isError = status === 'error'

  if (status === 'success' && urlIsDefined && !triggered) {
    // this is an external link followed throught js so we cannot use router here
    // eslint-disable-next-line no-restricted-properties
    window.location.replace(url)
    setTriggered(true)
  }

  useEffect(() => {
    if (isError) {
      logEvent('export_download_failed')
    }
  }, [isError])

  return (
    <FlowPageLayout>
      <div>
        {isError || !urlIsDefined ? (
          <EmptyStateWithRipple
            tint='feedback.error.500'
            Icon={Icons.Error}
            title={!urlIsDefined ? undefined : t('auth.verify_email_link_expired')}
            description={
              !urlIsDefined ? t('export_menu.invalid_link') : t('export_menu.expired_link')
            }
          />
        ) : (
          <EmptyStateWithRipple
            tint='feedback.success.500'
            Icon={Icons.DownloadCircle}
            description={t('export_menu.ongoing_download')}
          />
        )}
      </div>
    </FlowPageLayout>
  )
}

export const Component = Export
export default Export
